<ng-container [formGroup]="metadataFormGroup">
  <app-shared-business-form
    [formGroup]="sharedBusinessFormGroup"
    [showStaffFields]="false"
    [showActivityFields]="false"
  />

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations contractuelles
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Date de début</label>
      <input type="date" class="form-control" formControlName="startDate" />
    </div>
    <div class="col">
      <label i18n>Durée du contrat</label>
      <input
        type="text"
        class="form-control"
        formControlName="contractDuration"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Mode de paiement</label>
      <select class="form-control" formControlName="paymentFrequency">
        <option [ngValue]="null" i18n>Sélectionner</option>
        <option *ngFor="let value of paymentFrequencyValues" [ngValue]="value">
          {{ getPaymentFrequencyLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Supplément pour paiement fractionné en %</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="splitPaymentFee"
      />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations LPP
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>Plan de retraite</label>
      <select class="form-control" formControlName="retirementPlan">
        <option *ngFor="let plan of retirementPlanValues" [ngValue]="plan">
          {{ getBusinessRetirementPlanLabel(plan) }}
        </option>
      </select>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Personnel assuré
  </div>

  <div formArrayName="staff">
    <div
      class="staff-row"
      *ngFor="let staffControl of staff.controls; let i = index"
    >
      <div class="row w-100">
        <div class="staff-header w-100">
          <h6 class="mb-0" i18n>Personnel {{ i + 1 }}</h6>
          <button
            type="button"
            class="remove-staff-btn"
            (click)="removeStaffMember(i)"
            *ngIf="canRemoveStaff"
          >
            ✕
          </button>
        </div>

        <ng-container [formGroup]="getStaffGroup(i)">
          <div class="col-12 my-2" *ngIf="collaborators.length > 0">
            <label i18n>Collaborateur</label>
            <select class="form-control" formControlName="collaboratorId">
              <option [ngValue]="null" i18n>
                Sélectionner un collaborateur (optionnel)
              </option>
              <option
                *ngFor="let collaborator of collaborators"
                [ngValue]="collaborator.id"
              >
                {{ collaborator.firstName }} {{ collaborator.lastName }}
              </option>
            </select>
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Prénom *</label>
            <input
              type="text"
              class="form-control"
              formControlName="firstName"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Nom *</label>
            <input
              type="text"
              class="form-control"
              formControlName="lastName"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Date de naissance</label>
            <input
              type="date"
              class="form-control"
              formControlName="birthDate"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Sexe</label>
            <select class="form-control" formControlName="gender">
              <option *ngFor="let gender of sexValues" [ngValue]="gender">
                {{ getSexEnumLabel(gender) }}
              </option>
            </select>
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Numéro AVS</label>
            <input
              type="text"
              class="form-control"
              formControlName="avsNumber"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Salaire (CHF)</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="salary"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Poste</label>
            <input
              type="text"
              class="form-control"
              formControlName="position"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Marié(e)</label>
            <div class="form-check">
              <input
                type="radio"
                [id]="'married_' + i + '_false'"
                [value]="false"
                formControlName="married"
              />
              <label class="form-check-label" [for]="'married_' + i + '_false'">
                Non
              </label>
            </div>
            <div class="form-check">
              <input
                type="radio"
                [id]="'married_' + i + '_true'"
                [value]="true"
                formControlName="married"
              />
              <label class="form-check-label" [for]="'married_' + i + '_true'">
                Oui
              </label>
            </div>
          </div>
          <div
            class="col-md-6 col-sm-12 my-2"
            *ngIf="
              getStaffGroup(i).value.married === 'true' ||
              getStaffGroup(i).value.married === true
            "
          >
            <label i18n>Date de mariage</label>
            <input
              type="date"
              class="form-control"
              formControlName="marriageDate"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Taux d'activité</label>
            <input
              type="text"
              class="form-control"
              formControlName="activityRate"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Début d'activité</label>
            <input
              type="date"
              class="form-control"
              formControlName="activityStart"
            />
          </div>
          <div class="col-md-6 col-sm-12 my-2">
            <label i18n>Avoir LPP</label>
            <input type="text" class="form-control" formControlName="dues" />
          </div>
          <div class="col-12 my-2">
            <label i18n>Adresse</label>
            <input type="text" class="form-control" formControlName="address" />
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <button
    type="button"
    class="btn btn-light add-staff-btn me-auto ms-auto mt-4"
    (click)="addStaffMember()"
  >
    <span class="plus_sign me-2">+</span>
    <span i18n>Ajouter un membre du personnel</span>
  </button>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations supplémentaires
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Nombre de groupes d'assurés</label>
      <select class="form-control" formControlName="plan">
        <option [ngValue]="null" i18n>-</option>
        <option *ngFor="let plan of collaboratorLPPPlanValues" [ngValue]="plan">
          {{ getCollaboratorLPPPlanLabel(plan) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Nombre de collaborateurs</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="collaboratorsCount"
      />
    </div>
  </div>

  <div class="row row-cols-1 my-3">
    <div class="col">
      <label i18n>Déduction de coordination</label>
      <div class="form-check">
        <input
          type="radio"
          name="coordinationDeduction"
          id="coordinationDeductionFalse"
          [value]="false"
          formControlName="coordinationDeduction"
        />
        <label class="form-check-label" for="coordinationDeductionFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="coordinationDeduction"
          id="coordinationDeductionTrue"
          [value]="true"
          formControlName="coordinationDeduction"
        />
        <label class="form-check-label" for="coordinationDeductionTrue">
          Oui
        </label>
      </div>
    </div>
    <div class="col">
      <label i18n>Salaire assuré</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="insuredSalary"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n
        >Si salaire AVS plafonné et coordonné, plafonnement épargne</label
      >
      <select class="form-control" formControlName="retirementType">
        <option [ngValue]="null" i18n>-</option>
        <option *ngFor="let type of retirementTypeValues" [ngValue]="type">
          {{ getBusinessLPPTypeLabel(type) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Autre montant</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="otherAmount"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Temps partiel inclus</label>
      <div class="form-check">
        <input
          type="radio"
          name="partTimeIncluded"
          id="partTimeIncludedFalse"
          [value]="false"
          formControlName="partTimeIncluded"
        />
        <label class="form-check-label" for="partTimeIncludedFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="partTimeIncluded"
          id="partTimeIncludedTrue"
          [value]="true"
          formControlName="partTimeIncluded"
        />
        <label class="form-check-label" for="partTimeIncludedTrue"> Oui </label>
      </div>
    </div>
    <div class="col">
      <label i18n>Salaire minimal assuré</label>
      <div class="form-check">
        <input
          type="radio"
          name="minimalSalaryInsured"
          id="minimalSalaryInsuredFalse"
          [value]="false"
          formControlName="minimalSalaryInsured"
        />
        <label class="form-check-label" for="minimalSalaryInsuredFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="minimalSalaryInsured"
          id="minimalSalaryInsuredTrue"
          [value]="true"
          formControlName="minimalSalaryInsured"
        />
        <label class="form-check-label" for="minimalSalaryInsuredTrue">
          Oui
        </label>
      </div>
    </div>
  </div>

  <div class="row row-cols-1 my-3">
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.minimalSalaryInsured === false ||
        metadataFormGroup.value.minimalSalaryInsured === 'false'
      "
    >
      <label i18n>Si autre, montant</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="otherInsuredSalary"
      />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Tranches d'âge et taux de cotisations
  </div>

  <div formGroupName="contributions">
    <div class="row my-3">
      <div class="col-md-6 col-sm-12">
        <label i18n>De 18 à 24 ans</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="eighteenToTwentyFour"
        />
      </div>
      <div class="col-md-6 col-sm-12">
        <label i18n>De 25 à 34 ans</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="twentyFiveToThirtyFour"
        />
      </div>
    </div>
    <div class="row my-3">
      <div class="col-md-6 col-sm-12">
        <label i18n>De 35 à 44 ans</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="thirtyFiveToFourtyFour"
        />
      </div>
      <div class="col-md-6 col-sm-12">
        <label i18n>De 45 à 54 ans</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="fourtyFiveToFiftyFour"
        />
      </div>
    </div>
    <div class="row my-3">
      <div class="col-md-6 col-sm-12">
        <label i18n>De 55 à 64/65 ans</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="fiftyFiveTosixtyFive"
        />
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Assurance actuelle
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Possède une assurance</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceFalse"
          [value]="false"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceTrue"
          [value]="true"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceTrue"> Oui </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.hasInsurance === 'true' ||
        metadataFormGroup.value.hasInsurance === true
      "
    >
      <label i18n>Assureur actuel</label>
      <input
        type="text"
        class="form-control"
        formControlName="currentInsurer"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>A subi des sinistres ces 5 dernières années</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>
</ng-container>
